<!-- Recent Interactions -->
<div
  class="flex flex-column conversation-wrapper"
  [attr.data-testid]="'conversation-wrapper'"
>
  <div
    class="conversation-content-area flex flex-column flex-1 min-h-0 overflow-hidden"
  >
    <!-- Header -->
    <div
      class="flex align-items-center justify-content-between surface-200 px-3 border-round flex-shrink-0"
      [formGroup]="filterForm"
      [attr.data-testid]="'filter-header'"
    >
      @if (showMax() > 0) {
        <h5
          class="text-sm mr-2 mb-0 white-space-nowrap"
          [attr.data-testid]="'activity-feed-title'"
        >
          {{ 'CLIENT_INTERACTION.ACTIVITY_FEED' | translate }}
        </h5>
      }
      @if (!showSkeleton) {
        <div class="flex align-items-center">
          <p-select
            [options]="tenants"
            formControlName="selectedTenant"
            dropdownIcon="fa fa-caret-down text-primary"
            optionLabel="name_primary_language"
            filterBy="name_primary_language"
            styleClass="text-sm surface-200 border-none shadow-none p-0 flex align-items-center"
            placeholder="Select Tenant..."
            (onChange)="filterInteractions()"
            [attr.aria-label]="'tenant-dropdown'"
            [attr.data-testid]="'tenant-dropdown'"
          >
            <ng-template pTemplate="selectedItem">
              @if (selectedTenant && selectedTenant.value) {
                <div
                  class="text-sm text-primary font-bold flex align-items-center max-w-10rem overflow-hidden white-space-nowrap text-overflow-ellipsis"
                  pTooltip="{{ selectedTenant.value.name_primary_language }}"
                  tooltipStyleClass="text-xs"
                  [attr.data-testid]="'selected-tenant'"
                >
                  {{ selectedTenant.value.name_primary_language }}
                </div>
              }
            </ng-template>
            <ng-template let-tenant pTemplate="item">
              <div
                class="text-sm"
                [attr.data-testid]="'tenant-option-' + tenant.id"
              >
                {{ tenant.name_primary_language }}
              </div>
            </ng-template>
          </p-select>
          <div (click)="filter_by.toggle($event)">
            <p-button
              icon="fa fa-filter"
              label="Filter By"
              styleClass="p-button-text text-sm hidden md:inline-block"
              [ngClass]="
                (clientInteractions$ | async).length === 0
                  ? 'opacity-40 pointer-events-none'
                  : ''
              "
              [attr.aria-label]="'filter-button'"
              [attr.data-testid]="'filter-button'"
            />
            <p-button
              icon="fa fa-filter"
              styleClass="p-button-text md:hidden"
              [ngClass]="
                (clientInteractions$ | async).length === 0
                  ? 'opacity-40 pointer-events-none'
                  : ''
              "
              [attr.aria-label]="'filter-button-mobile'"
              [attr.data-testid]="'filter-button-mobile'"
            />
            <p-popover
              #filter_by
              styleClass="w-20rem"
              [attr.data-testid]="'filter-panel'"
            >
              <ng-template #content>
                <!-- Dropdown Content -->
                <div
                  class="-mx-4 -mt-4 p-3 border-bottom-1 border-300"
                  [attr.data-testid]="'select-all-section'"
                >
                  <p-checkbox
                    checkboxIcon="fa fa-check"
                    binary="true"
                    formControlName="selectAll"
                    (onChange)="selectAll($event)"
                    [attr.aria-label]="'select-all-checkbox'"
                    [attr.data-testid]="'select-all-checkbox'"
                  />
                  <label
                    for="selectAll"
                    class="text-sm cursor-pointer text-primary ml-2"
                    [attr.data-testid]="'select-all-label'"
                    >{{ 'CLIENT_INTERACTION.SELECT_ALL' | translate }}</label
                  >
                </div>
                <!-- Dropdown Content -->
                <!-- Dropdown Content -->
                <div
                  class="p-3 -mx-4 -mb-4 flex border-bottom-1 border-300"
                  [attr.data-testid]="'task-type-section'"
                >
                  <div class="w-6 pl-3">
                    <div>
                      <p-checkbox
                        checkboxIcon="fa fa-check"
                        binary="true"
                        inputId="taskType"
                        formControlName="selectAllTask"
                        (onChange)="selectAllTask($event)"
                        [attr.aria-label]="'select-all-task-checkbox'"
                        [attr.data-testid]="'select-all-task-checkbox'"
                      />
                      <label
                        for="taskType"
                        class="text-sm cursor-pointer font-bold ml-2"
                        [attr.data-testid]="'task-type-label'"
                        >{{ 'TASK_LIST.TASK_TYPE' | translate }}</label
                      >
                    </div>
                    <ul
                      class="list-none m-0 pl-3 text-xs"
                      [attr.data-testid]="'task-type-list'"
                    >
                      <li class="mt-2" [attr.data-testid]="'call-option'">
                        <p-checkbox
                          checkboxIcon="fa fa-check"
                          value="Call"
                          name="group1"
                          inputId="call"
                          [formControl]="filterForm.controls['selectedTasks']"
                          [attr.aria-label]="'call-checkbox'"
                          [attr.data-testid]="'call-checkbox'"
                        />
                        <label
                          for="call"
                          class="cursor-pointer ml-2"
                          [attr.data-testid]="'call-label'"
                          >{{ 'TASK_LIST.CALL' | translate }}</label
                        >
                      </li>
                      <li class="mt-2" [attr.data-testid]="'sms-option'">
                        <p-checkbox
                          checkboxIcon="fa fa-check"
                          value="Sms"
                          name="group1"
                          inputId="sms2"
                          [formControl]="filterForm.controls['selectedTasks']"
                          [attr.aria-label]="'sms-checkbox'"
                          [attr.data-testid]="'sms-checkbox'"
                        />
                        <label
                          for="sms2"
                          class="cursor-pointer ml-2"
                          [attr.data-testid]="'sms-label'"
                          >{{ 'TASK_LIST.SMS' | translate }}</label
                        >
                      </li>
                      <li class="mt-2" [attr.data-testid]="'email-option'">
                        <p-checkbox
                          checkboxIcon="fa fa-check"
                          value="Email"
                          name="group1"
                          inputId="email"
                          [formControl]="filterForm.controls['selectedTasks']"
                          [attr.aria-label]="'email-checkbox'"
                          [attr.data-testid]="'email-checkbox'"
                        />
                        <label
                          for="email"
                          class="cursor-pointer ml-2"
                          [attr.data-testid]="'email-label'"
                          >{{ 'TASK_LIST.EMAIL' | translate }}</label
                        >
                      </li>
                      <li class="mt-2" [attr.data-testid]="'tour-option'">
                        <p-checkbox
                          checkboxIcon="fa fa-check"
                          value="Tour"
                          name="group1"
                          inputId="meetingTour"
                          [formControl]="filterForm.controls['selectedTasks']"
                          [attr.aria-label]="'tour-checkbox'"
                          [attr.data-testid]="'tour-checkbox'"
                        />
                        <label
                          for="meetingTour"
                          class="cursor-pointer ml-2"
                          [attr.data-testid]="'tour-label'"
                          >{{
                            'CLIENT_INTERACTION.MEETING_TOUR' | translate
                          }}</label
                        >
                      </li>
                      <li class="mt-2" [attr.data-testid]="'whatsapp-option'">
                        <p-checkbox
                          checkboxIcon="fa fa-check"
                          value="Whatsapp"
                          name="group1"
                          inputId="Whatsapp"
                          [formControl]="filterForm.controls['selectedTasks']"
                          [attr.aria-label]="'whatsapp-checkbox'"
                          [attr.data-testid]="'whatsapp-checkbox'"
                        />
                        <label
                          for="Whatsapp"
                          class="cursor-pointer ml-2"
                          [attr.data-testid]="'whatsapp-label'"
                          >{{ 'TASK_LIST.WHATSAPP' | translate }}</label
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- Dropdown Content -->
                <!-- Dropdown Content -->
                <div
                  class="-mx-4 -mt-4 p-3"
                  [attr.data-testid]="'date-filter-section'"
                >
                  <h6
                    class="mb-2 mt-3 font-bold text-sm"
                    [attr.data-testid]="'date-filter-title'"
                  >
                    {{ 'CLIENT_INTERACTION.FILTER_BY_DATE' | translate }}
                  </h6>
                  <div class="flex align-items-center">
                    <p-datepicker
                      [showIcon]="false"
                      [placeholder]="
                        'OUTCOME.CALLOUTCOME.SELECTDATE' | translate
                      "
                      formControlName="fromDate"
                      styleClass="w-full"
                      inputStyleClass="text-sm"
                      [attr.aria-label]="'from-date-calendar'"
                      [attr.data-testid]="'from-date-calendar'"
                    />
                    <div class="text-sm mx-2" [attr.data-testid]="'to-label'">
                      {{ 'CLIENT_INTERACTION.TO' | translate }}
                    </div>
                    <p-datepicker
                      [showIcon]="false"
                      [placeholder]="
                        'OUTCOME.CALLOUTCOME.SELECTDATE' | translate
                      "
                      formControlName="toDate"
                      styleClass="w-full"
                      inputStyleClass="text-sm"
                      [attr.aria-label]="'to-date-calendar'"
                      [attr.data-testid]="'to-date-calendar'"
                    />
                  </div>
                </div>
                <!-- Dropdown Content -->
                <!-- Dropdown Content -->
                <div
                  class="-mx-4 -mb-4 border-top-1 border-300 p-3 flex align-items-center justify-content-between"
                  [attr.data-testid]="'filter-actions'"
                >
                  <button
                    pButton
                    pRipple
                    type="button"
                    [label]="'CLIENT_INTERACTION.BTN_RESET' | translate"
                    class="p-button-danger p-button-text text-sm"
                    (click)="resetFilter(); filter_by.hide($event)"
                    [attr.aria-label]="'reset-button'"
                    [attr.data-testid]="'reset-button'"
                  ></button>
                  <button
                    pButton
                    pRipple
                    type="button"
                    [label]="'CLIENT_INTERACTION.BTN_APPLY' | translate"
                    class="text-sm"
                    (click)="getFilterData(); filter_by.hide($event)"
                    [attr.aria-label]="'apply-button'"
                    [attr.data-testid]="'apply-button'"
                  ></button>
                </div>
                <!-- Dropdown Content -->
              </ng-template>
            </p-popover>
          </div>
        </div>
      }
      @if (showSkeleton) {
        <p-skeleton
          height="2rem"
          styleClass="w-6rem"
          [attr.data-testid]="'header-skeleton'"
        />
      }
    </div>
    <!-- Header -->

    <!-- Content -->
    @if (!showSkeleton) {
      <div
        class="text-xs interactions-content flex-1 min-h-0 overflow-hidden"
        [attr.data-testid]="'interactions-content'"
      >
        <!-- Card -->
        <conversation-logs
          class="h-full"
          [interactions]="clientInteractions$.value"
          [showSkeleton]="showSkeleton"
          [clientDetails]="client()"
          [height]="height()"
          [interactionId]="interactionId()"
          [tenantId]="selectedTenant.value.id"
          [attr.aria-label]="'conversation-logs'"
          [attr.data-testid]="'conversation-logs'"
        />
        <!-- Card -->
        <!-- Interactions -->
        <ng-template #noInteraction>
          <div
            class="text-sm pt-8 mt-5 text-center h-27rem"
            [attr.data-testid]="'no-interactions-message'"
          >
            <div class="my-4" [attr.data-testid]="'no-interactions-text'">
              {{ 'CLIENT_INTERACTION.NO_INTRACTION' | translate }}
            </div>
            <img
              src="/assets/img/empty-state-activity-feeds-img.svg"
              [alt]="'CLIENT_INTERACTION.NO_INTRACTION' | translate"
              [attr.data-testid]="'no-interactions-image'"
            />
          </div>
        </ng-template>
        <!-- Interactions -->
      </div>
    }
    <!-- Content -->
  </div>

  <div class="conversation-reply-area flex-shrink-0">
    <!-- Add Comment -->
    @if (isTwoWayNotificationEnabled && !showSkeleton) {
      <reply
        [client]="client()"
        [lastInteraction]="lastInteraction"
        [tenantId]="tenantId"
        [showDotColor]="showDotColor"
        (newInteraction)="getNewInteraction($event)"
        [multiChannel]="true"
        [attr.aria-label]="'reply-section'"
        [attr.data-testid]="'reply-section'"
      />
    }
    <!-- Add Comment -->
  </div>

  <!-- Content Skeleton -->
  @if (showSkeleton) {
    <div class="my-2" [attr.data-testid]="'content-skeleton'">
      @if (showSkeleton) {
        <p-skeleton
          height="4rem"
          styleClass="w-full mb-2"
          [attr.data-testid]="'skeleton-row-1'"
        />
      }
      @if (showSkeleton) {
        <p-skeleton
          height="4rem"
          styleClass="w-full mb-2"
          [attr.data-testid]="'skeleton-row-2'"
        />
      }
      @if (showSkeleton) {
        <p-skeleton
          height="4rem"
          styleClass="w-full mb-2"
          [attr.data-testid]="'skeleton-row-3'"
        />
      }
      @if (showSkeleton) {
        <p-skeleton
          height="4rem"
          styleClass="w-full mb-2"
          [attr.data-testid]="'skeleton-row-4'"
        />
      }
      @if (showSkeleton) {
        <p-skeleton
          height="4rem"
          styleClass="w-full mb-2"
          [attr.data-testid]="'skeleton-row-5'"
        />
      }
    </div>
  }
  <!-- Content Skeleton -->

  @if (showSkeleton) {
    <p-skeleton
      height="2rem"
      styleClass="w-full"
      [attr.data-testid]="'footer-skeleton'"
    />
  }
</div>
<!-- Recent Interactions -->
